import { camelizedJSONFetch } from '../fetchShim';
import { GET_PROCESSING_FEES_PATH } from './constants';
import type { GetProcessingFeesRequestParams, GetProcessingFeesResponse } from './types';

export const getProcessingFees = async ({ merchantToken }: GetProcessingFeesRequestParams) => {
  const queryParams = new URLSearchParams({
    merchant_token: merchantToken,
  });
  return camelizedJSONFetch<GetProcessingFeesResponse>(
    `${GET_PROCESSING_FEES_PATH}?${queryParams.toString()}`,
    { method: 'GET' },
  );
};
